import React from 'react'
import { Formik, Form, Field, FormikHelpers } from 'formik'
import { TextField } from 'formik-mui'
import * as Yup from 'yup'
import { Button, Grid } from '@mui/material'
import { TypePriority } from '../../../interfaces'

interface TypePriorityFormProps {
  initialValues: TypePriority
  onSubmit: (
    values: TypePriority,
    formikHelpers: FormikHelpers<TypePriority>
  ) => void | Promise<void>
  onCancel?: () => void
}

const validationSchema = Yup.object({
  name: Yup.string().required('El nombre es obligatorio'),
  value: Yup.number()
    .typeError('Debe ser un número')
    .required('El valor es obligatorio')
})

export const TypePriorityForm: React.FC<TypePriorityFormProps> = ({
  initialValues,
  onSubmit,
  onCancel
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, dirty, resetForm }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name='name'
                label='Nombre'
                fullWidth
                variant='outlined'
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                component={TextField}
                name='value'
                label='Valor'
                type='number'
                fullWidth
                variant='outlined'
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              spacing={1}
              alignItems='flex-end'
              alignContent='flex-end'
              justifyContent='flex-end'
            >
              <Grid item>
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  disabled={isSubmitting || !dirty}
                >
                  {'Guardar'}
                </Button>
              </Grid>
              {onCancel && (
                <Grid item>
                  <Button
                    variant='outlined'
                    disabled={isSubmitting}
                    onClick={() => {
                      resetForm()
                      onCancel()
                    }}
                  >
                    Cancelar
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
